import { jsx as _jsx } from "react/jsx-runtime";
import { ReactFlow, Background, BackgroundVariant } from '@xyflow/react';
import { GRID_HEX } from '../../../constants';
import '@xyflow/react/dist/style.css';
const RFRenderEmptyFC = () => {
    return (_jsx(ReactFlow, { nodes: [], edges: [], maxZoom: 1, minZoom: 1, children: _jsx(Background, { variant: BackgroundVariant.Lines, color: GRID_HEX, gap: 50 }) }));
};
export const RFRenderEmpty = RFRenderEmptyFC;
//# sourceMappingURL=RFRenderEmpty.js.map